import { SEARCHFILTER, STATUSCHANGED } from "./actionType";

export const statusChanged = (changeStatus) => {
  return {
    type: STATUSCHANGED,
    payload: changeStatus,
  };
};

export const searchFilter = (searchInput) => {
  return {
    type: SEARCHFILTER,
    payload: searchInput,
  };
};
